















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EventTree extends Vue {
  @Prop() eventErrorList!: Event[];

  showContext(context: string, date: Date) {
    this.$emit('showContext', context, date);
  }
}
